<template>
  <div class="document-dialog" v-if="showMessageBox">
    <el-dialog
      :visible.sync="showMessageBox"
      top="30vh"
      :center="false"
      width="360px"
      style="border-radius:15px"
      :close-on-click-modal="false"
      :before-close="close"
    >
      <div slot="title" class="dialog-title ml5 left">{{ showTitle }}</div>
      <div class="login-tip">
        <div class="msgTitle" v-if="showBtn === '去划词使用'">
          您当前暂未划取内容
        </div>
        {{ showMessage }}
        <div v-if="showBtn === '去划词使用'">
          <img src="../../assets/image/prompt/slideLeft.gif" />
        </div>
      </div>

      <div slot="footer" class="dialog-footer ml5 center">
        <el-button size="mini" class="dialog-tologin" @click="tologin">{{
          showBtn
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "messageBox",
  props: {
    showMessageBox: {
      type: Boolean,
      default: false
    },
    showTitle: {
      type: String,
      default: ""
    },
    showMessage: {
      type: String,
      default: ""
    },
    showBtn: {
      type: String,
      default: ""
    }
  },
  methods: {
    tologin() {
      this.close();
    },
    close() {
      this.$emit("closeShowMessageBox", false);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
.document-dialog {
  .login-tip {
    text-align: center;
    margin: 10px 0;
    line-height: 22px;
    font-size: 12px;
    .msgTitle {
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 20px;
    }
    img {
      margin-top: 10px;
    }
  }
  .dialog-tologin {
    background-color: @theme-color;
    color: white;
    border-radius: 20px;
    padding: 8px 20px;
  }
  .dialog-document .dialog-title {
    font-size: 14px;
  }
  /deep/.el-dialog__header {
    border-bottom: 1px solid #e2e3e5;
    padding: 15px 20px 15px;
  }
  /deep/.el-dialog {
    border-radius: 4px;
  }
  /deep/.el-dialog__body {
    padding: 20px 20px 0 20px;
  }
}
</style>
